import { render, staticRenderFns } from "./event_form.vue?vue&type=template&id=495ebda7&"
import script from "./event_form.vue?vue&type=script&lang=js&"
export * from "./event_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports